import {Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField} from "@mui/material"
import {useDispatch, useSelector} from "react-redux"
import {useEffect, useState} from "react"
import {
	clearResults, resetUserSearchError,
	searchNonWorkspaceUsersByLastName,
	searchUsersByLastName,
	selectIsSearchingUsers,
	selectSearchResults, selectUserSearchError
} from "../reducers/userSearchSlice"
import {debounce} from "lodash"
import {useSnackbar} from "notistack"
import LoadingNoContainer from "../components/LoadingNoContainer"

export const LookupTypes = {
	GLOBAL: "GLOBAL",
	NON_WORKSPACE_MEMBERS: "NON-WORKSPACE-MEMBERS",
}

export function UserLookup({
	lookupType = LookupTypes.GLOBAL,
	onSelectUserCB,
	showTier = true,
	maxListHeight = "40vh",
	controlScroll = true
}) {
	const dispatch = useDispatch()
	const {enqueueSnackbar} = useSnackbar()
	const [searchString, setSearchString] = useState("")
	const searchResults = useSelector(selectSearchResults)
	const isSearching = useSelector(selectIsSearchingUsers)
	const userSearchError = useSelector(selectUserSearchError)

	const handleChange = (query) => {
		if(query.length >= 3) {
			if(lookupType === LookupTypes.GLOBAL){
				dispatch(searchUsersByLastName(query))
			}

			if(lookupType === LookupTypes.NON_WORKSPACE_MEMBERS){
				dispatch(searchNonWorkspaceUsersByLastName(query))
			}
		} else if (searchString && query.length <= 0) {
			dispatch(clearResults())
		}
	}

	useEffect(() => {
		if(userSearchError) {
			enqueueSnackbar(
				userSearchError,
				{
					variant: "error",
					autoHideDuration: 5000,
					onClose: () => {
						dispatch(resetUserSearchError())
					}
				}
			)
		}
	}, [userSearchError])

	const debouncedSearch = debounce(handleChange, 300)

	return (
		<Box
			fullWidth
			className={"userlookup-container"}
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "40vh"
			}}
		>
			<TextField
				onKeyDown={(e) => e.stopPropagation()}
				label="Search Users"
				variant="standard"
				value={searchString}
				fullWidth
				className={"userlookup-input"}
				onChange={(e) => {
					setSearchString(e.target.value)
					debouncedSearch(e.target.value)
				}}
				sx={{flex: "0 0 auto"}}
			/>
			<TableContainer
				className={"userlookup-results-container"}
				sx={{
					height: "calc(100% - 90px)",
					overflowX: "hidden",
					overflowY: controlScroll ? "scroll" : "initial",
					maxHeight: maxListHeight,
					flex: "1 0 40vh",
					// borderTop: "none",
					// borderBottom: "1px solid black",
					// borderLeft: "1px solid black",
					// borderRight: "1px solid black",
				}}
			>
				{ isSearching === true && (
					<Box pt={"2rem"}>
						<LoadingNoContainer />
					</Box>
				)}
				{ (searchString.length >= 3 && !isSearching) && (
					<Table stickyHeader className={"userlookup-results"}>
						<TableHead>
							{ searchResults.length >= 1 && (
								<TableRow>
									<TableCell variant={"head"} sx={{fontWeight: 700}}>
										User Name
									</TableCell>
									<TableCell variant={"head"} sx={{fontWeight: 700}}>
										E-mail
									</TableCell>
									{ showTier && (
										<TableCell variant={"head"} sx={{fontWeight: 700}}>
											Status
										</TableCell>
									)}
								</TableRow>
							)}
							{ searchString.length >= 3 && searchResults.length < 1 && !isSearching && (
								<TableRow>
									<TableCell
										align={"center"}
										variant={"head"}
										sx={{fontWeight: 700}}
									>
										No more results found.
									</TableCell>
								</TableRow>
							)}
						</TableHead>
						{ searchResults.length >= 1 && (
							<TableBody>
								{ searchResults.map((user) => (
									<TableRow
										key={user.id}
										onClick={()=> onSelectUserCB(user)}
										sx={{
											cursor: "pointer",
											"&:hover": {
												backgroundColor: "action.focus"
											},
										}}
									>
										<TableCell>
											{`${user.firstName} ${user.lastName}`}
										</TableCell>
										<TableCell>
											{user.email}
										</TableCell>
										{showTier && (
											<TableCell>
												{user.ownsSubscription ? "Paid" : "Free"}
											</TableCell>
										)}
									</TableRow>
								))}
							</TableBody>
						)}
					</Table>
				)}
			</TableContainer>
		</Box>
	)
}